import { Component } from '@angular/core';
import { ThemeService } from '@shared/services';

@Component({
  selector: 'app-home-component',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  constructor(
    public themeService: ThemeService
  ) { }
}
